import { SECONDS_PER_MINUTE } from '@/utils';

export type CountdownFormat = 'seconds' | 'minutes-seconds';

export function formatCountdown(
  remainingSeconds: number,
  format: CountdownFormat = 'seconds'
): string {
  if (format === 'seconds') return String(remainingSeconds);

  const minutes = Math.floor(remainingSeconds / SECONDS_PER_MINUTE);
  const seconds = String(remainingSeconds % SECONDS_PER_MINUTE).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  return `${formattedMinutes}:${seconds}`;
}
